import {make} from "vuex-pathify";

const state = {
    loading: false,
}
const mutations = make.mutations(state)

const actions = {}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
